fetch(
	`${window.location.origin}/wp-json/wp/v2/categories_job?per_page=20&hide_empty=true`,
)
	.then((res) => res.json())
	.then((categories) => {
		fetch(
			`${
				window.location.origin
			}/wp-json/wp/v2/jobs?per_page=4&_embed&slug=${window.location.pathname
				.split("/")
				.filter(Boolean)
				.pop()}`,
		)
			.then((result) => {
				if (result.ok) {
					return result.json();
				}
				// if (result.status === 400) {
				//   containerCards.innerHTML = "<p>No se encontraron resultados</p>";
				// }

				throw new Error("Something went wrong");
			})
			.then((data) => {
				const authorContainer = document.querySelector(
					".sc-hero-legal-container__content-container__desc",
				);
				data?.[0].categories_job.map((item) => {
					authorContainer.insertAdjacentHTML(
						"afterbegin",
						`<mark>${categories.find((itm) => itm.id == item).name}</mark>`,
					);
				});
			});
	});
